// extracted by extract-css-chunks-webpack-plugin
module.exports = {"saved-items-page":"h25N7iyyLdo72WCY3lVd","title":"WZgDjUnWxLuMIxnvSzaZ","grid":"F3y01tkQ2GBG3fkK1Sq5","heart":"vCsZcduw32LRtx4hf0m4","startSearch":"jRQnpGzzQjW_xBeYMDCJ"};